var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7214_17115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1978 8.00007L12.9748 10.0313L15.3644 11.5584L15.7811 8.01257L15.3644 4.5459L12.929 5.88757L11.1978 8.00007Z",
    fill: "#1D282D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.885254 11.2292V14.2501C0.885254 14.9407 1.44463 15.5001 2.13525 15.5001H5.15609L5.78109 13.2167L5.15609 11.2292L3.08317 10.6042L0.885254 11.2292Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15609 0.5L0.885254 4.77083L3.08317 5.39583L5.15609 4.77083L5.77067 2.81042L5.15609 0.5Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15609 4.77075H0.885254V11.2291H5.15609V4.77075Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0937 2.30844L15.3646 4.54594V11.5584L18.1063 13.8064C18.5167 14.1272 19.1167 13.8345 19.1167 13.3126V2.79178C19.1167 2.26365 18.5031 1.97407 18.0937 2.30844ZM11.1979 8.00011V11.2293H5.15625V15.5001H14.1146C14.8052 15.5001 15.3646 14.9407 15.3646 14.2501V11.5584L11.1979 8.00011Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1146 0.5H5.15625V4.77083H11.1979V8L15.3646 4.54792V1.75C15.3646 1.05937 14.8052 0.5 14.1146 0.5Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7214_17115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2292,
    height: 15,
    fill: "white",
    transform: "translate(0.885254 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.52fcce301cd29dc4f062dfcaa751ba5c.svg";
export { ForwardRef as ReactComponent };